import { Injectable } from '@angular/core';
import Amplify, { Auth } from 'aws-amplify';
import { environment } from 'src/environments/environment';

// The single Amplify.configure for the whole app -- it is global, so a second one anywhere else
// would silently overwrite this. No identityPoolId (none exists in us-east-1, and nothing calls
// Auth.currentCredentials), and no Storage block (photo upload goes through the API's presigned
// URL in image-upload.service.ts, so Amplify Storage was never used).
Amplify.configure({
  Auth: {
    region: environment.region,
    userPoolId: environment.userPoolId,
    userPoolWebClientId: environment.userPoolWebClientId,
  },
  aws_appsync_graphqlEndpoint: environment.appsyncGraphQLEndpoint,
  aws_appsync_region: environment.appsyncRegion,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS'
})
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor() { }

  async signIn(email, password) {
    return await Auth.signIn(email, password).then((response) => {
      console.log("Login response: ", response);
      if (response) {
        const res =
          (response) ||
          {};
        return res;
      }
      return false;
    })
      .catch((err) => {
        console.log(err);
        return err.name;
      }
      );
  }

  async GetAuthenticationToken() {
    return await Auth.currentSession().then((response) => {
      console.log(" Token response: ", response);
      if (response) {
        const res =
          (response) ||
          {};
        return res;
      }
      return false;
    })
      .catch((err) => {
        console.log(err);
        return err.name;
      }
      );
  }

  async signUp(data) {
    return await Auth.signUp(data).then((response) => {
      console.log("Register response: ", response);
      if (response) {
        const user =
          (response) ||
          {};
        return user;
      }
      return false;
    })
      .catch((err) => {
        console.log(err.message);
        return err.name;
      });
  }

  async signOut() {
    try {
      await Auth.signOut(); // clears Cognito tokens in the app
    } catch (e) {
      console.error('Auth.signOut failed', e);
      // still clear app state below even if this fails
    }
  }

  async verifyCode(email, code) {
    return await Auth.confirmSignUp(email, code).then((response) => {
      console.log("verification of code response: ", response);
      if (response) {
        const user =
          (response) ||
          {};
        return user;
      }
      return false;
    })
      .catch((err) => {
        console.log(err.message);
        return err.name;
      });
  }

  async resendCode(email) {
    console.log(email)
    return await Auth.resendSignUp(email, { "metadataKey1": "metadataValue1" }).then((response) => {
      console.log("resend of code response: ", response);
      if (response) {
        const user =
          (response) || {};
        return user;
      }
      return false;
    })
      .catch((err) => {
        console.log(err.message);
        return err.name;
      });
  }

  async sendForgotPasswordCode(email) {
    return await Auth.forgotPassword(email).then((response) => {
      console.log("send code of forgot password response: ", response);
      if (response) {
        const user =
          (response) || {};
        return user;
      }
      return false;
    })
      .catch((err) => {
        console.log(err.message);
        return err.name;
      });
  }

  async forgotPassword(userName, code, password) {
    return await Auth.forgotPasswordSubmit(userName, code, password).then((response) => {
      console.log("forgot password response: ", response);
      if (response) {
        const user =
          (response) || {};
        return user;
      }
      return false;
    })
      .catch((err) => {
        console.log(err.message);
        return err.name;
      });
  }

}
